import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { SpecieAbstractService } from '~/services/api/web/specie/specieAbstractService';
import { HttpClientWrapper } from '~/services/api/httpClientWrapper';
import { BaseWebService } from '~/services/api/web/base/baseWebService';
import { ResponseModel } from '~/models/responseModel';
import { SpecieModel } from '~/models/specieModel';
import { ClipModel } from '~/models/clipModel';
import { Observable } from 'rxjs';
import { AssignSellerModel } from '~/models/assignSellerModel';
import { LineModel } from '~/models/lineModel';
import { ResponseModelCode } from '~/models/responseModel';
import { map as _map } from 'lodash';
import { BrandModel } from '~/models/brandModel';
import { EntityModel } from '~/models/entityModel';
import { InventorySpecieModel } from '~/models/inventorySpecieModel';
import { MobSummaryModel } from '~/models/mobSummaryModel';
import { ClipSummaryModel } from '~/models/clipSummaryModel';
import { LineLotSummaryModel } from '~/models/lineLotSummaryModel';
import { BreakDownModel, MobBreakDownModel } from '~/models/breakDownModel';

@Injectable()
export class SpecieService extends BaseWebService implements SpecieAbstractService {

    public static readonly PATH:string = '/species';

    constructor(http: HttpClientWrapper) {
        super(http);
    }

    public getSpecies(entity?: EntityModel, brand?: BrandModel): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH;

        let params = new HttpParams();

        if (entity.entityId) {
            params = params.append('entityId', entity.entityId.toString());
        }

        if (brand.brandId) {
            params = params.append('brandId', brand.brandId.toString());
        }

        let options:{} = {
            params: params
        };

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (specie) => new InventorySpecieModel(specie));
        });
    }

    public getSpecieById(specieId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + specieId.toString();

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new InventorySpecieModel(response['data']);
        });
    }

    public getMobsBySpeciId(speciId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + speciId.toString() + '/mobs';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (mob) => new MobSummaryModel(mob));
        });
    }

    public getBalesBySpeciId(speciId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + speciId.toString() + '/bales';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (bale) => new ClipSummaryModel(bale));
        });
    }

    public getLinesAndLotsBySpeciId(specieId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + specieId.toString() + '/linesandlots';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (lot) => new LineLotSummaryModel(lot));
        });
    }


    public getClipsBySpeciId(speciId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + speciId.toString() + '/clip';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (lot) => new ClipSummaryModel(lot));
        });
    }

    public getSpecieAverage(specieId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + specieId.toString() + '/average';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new BreakDownModel(response['data']);
        });
    }

    public getMobBreakDownBySpecie(specieId: number): Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + specieId.toString() + '/mob-breakdown';

        let options:{} = {};

        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return new MobBreakDownModel(response['data']);
        });
    }

    public getProductionByWoolType(specieId:number):Observable<ResponseModel> {
        let url:string = SpecieService.URL + SpecieService.PATH + '/' + specieId.toString() + '/production-by-wooltype';

        let options:{} = {};
        return this.http.get(url, options, (response: HttpResponse<any>) => {
            return _map(response['data'], (item:{}) => new BreakDownModel(item));
        });
    }
}
